import { calculateLocatinVars, getQueryParam } from '../../libs/browser';
import { logoutAccount } from '../../libs/state';
import { parseError } from '../../libs/parser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Badge from '@mui/material/Badge';
import CommonIconButton from '../../components/CommonIconButton';
import Context from '../../provider';
import IconLogout from '../../assets/hkdc/icons/NavbarLogout';
import IconNotification from '../../assets/hkdc/icons/NotificationIcon';
import IconSetting from '../../assets/hkdc/icons/SettingIcon';
import React, { useContext, useEffect, useState } from 'react';
import config from '../../config';
import memberApi from '../../libs/api/memberApi';
import useSetHtmlHeader from '../../hooks/useSetHtmlHeader';
import './index.scss';

export default function HeaderBarComponent(props) {
  const {
    homeIcon,
    homeBarStyle = {},
    homeIconStyle = {},
    iconStyle = {},
    homeFunctionStyle = {},
    isScrollPos = false
  } = props;

  const htmlHeader = useSetHtmlHeader({ themeColor: '#ffffff' });

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const { hasUnreadNotifications, isMobile, init, me, dispatch, navData } = useContext(Context);

  const [tierBenefitsData, setTierBenefitsData] = useState([]);
  const [vouchersData, setVouchersData] = useState([]);
  const [isLogin, setIsLogin] = useState(false);

  const fetchTierBenefitsData = async (page) => {
    try {
        const response = await memberApi.getTierBenefits({
            page,
            pageSize: 1
        });
        setTierBenefitsData((prevData) => [...prevData, ...(response?.list ?? []).filter((d) => !(prevData.find((p) => p.uri_name === d.uri_name)))]);
    } catch (error) {
        dispatch({
            type: 'SET_ERROR_DIALOG',
            payload: { open: true, ...parseError(error) }
        });
    }
};

const getItem = async (page) => {
  try {
    const response = await memberApi.getItems({
      page,
      pageSize: 1,
      status: 'available'
    });
    setVouchersData((prevData) => [...prevData, ...(response?.list ?? []).filter((i) => !(prevData.find((p) => p.id === i.id)))]);
  } catch (error) {
    dispatch({
      type: 'SET_ERROR_DIALOG',
      payload: { open: true, ...parseError(error) }
    });
  }
};

// This page only allow logged in user
  useEffect(() => {
    if (!isMobile && init) {
      console.log('home bar', locationVars, location, getQueryParam('language'));
      fetchTierBenefitsData(1);
      if (me?.status === 'activated'){
          getItem(1);
          setIsLogin(true);
      } else {
          setIsLogin(false);
      }
      }
  }, [init, me, isMobile]);

  const logout = () => {
    logoutAccount({ dispatch });
    navigate(`${config.basename}`);
};

  const handleNavbarClick = (type) => {
    // eslint-disable-next-line default-case
    switch (type) {
        case 'home':
            navigate(`${config.basename}`);
            break;
        case 'fellow':
            setTimeout(() => {
                navigate(`${config.basename}${"about-fohkdc"}`);
            }, 200);
            break;
        case 'news':
            navigate(`${config.basename}news`);
            break;
        case 'logout':
            logout();
            break;
        case 'benefits':
            navigate(`${config.basename}`, {
              state: {
                toClass: '.benefits-section-cont-bg'
              }
            });
            break;
        case 'login':
          setTimeout(() => {
            navigate(`${config.basename}${"join-membership-program"}`, {
              state: {
                defaultTierId: tierBenefitsData && tierBenefitsData.length > 0 ? tierBenefitsData[0].id : -1,
                defaultTierType: tierBenefitsData && tierBenefitsData.length > 0 ? tierBenefitsData[0].uri_name.replace('/tier-', '') : ''
              }
            });
          }, 200);
          break;
        case 'profile':
          navigate(`${config.basename}setting/profile/user`);
          break;
        case 'coupon':
          navigate(`${config.basename}`, {
            state: {
              toClass: '.vouchers-section'
            }
          });
          break;
    }
};

  return (
    <div className='web-max-container home-bar' style={homeBarStyle}>
      {homeIcon}
      <div className='home-function-cont' style={homeFunctionStyle}>
        <div className='home-function' style={homeIconStyle}>
          <Badge invisible={!hasUnreadNotifications} color="secondary" variant='dot'>
            <IconNotification
              className="home-btn"
              style={iconStyle}
              onClick={() => {
                navigate(`${config.basename}notifications`);
              }}
            />
          </Badge>
          <IconSetting
            className="home-btn"
            style={iconStyle}
            onClick={() => {
              navigate(`${config.basename}settings`);
            }}
          />
        </div>
        {
          !isMobile && (
            <div className='nav-cont'>
              <div className="nav-btn-cont">
                <CommonIconButton
                  text= { t('nav.home') }
                  alignItems = "unset"
                  backgroundColor= "#ffffff"
                  btnBackgroundColor= "#ffffff"
                  btnColor = { locationVars[0] === '' || locationVars[0] === 'home' || locationVars[0] === 'index.html' ? '#004899' : '#000000' }
                  width= "max-content"
                  padding = "0.25rem 0.5rem"
                  btnPadding="0rem"
                  btnFontSize = "1.125rem"
                  btnFontWeight = "700"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNavbarClick('home');
                  }}
                />
                {
                  !isLogin && (
                    <>
                      <CommonIconButton
                        text= { t('nav.about') }
                        alignItems = "unset"
                        backgroundColor= "#ffffff"
                        btnBackgroundColor= "#ffffff"
                        btnColor = { locationVars[0] === 'about-fohkdc' ? '#004899' : '#000000' }
                        width= "max-content"
                        padding = "0.25rem 0.5rem"
                        btnPadding="0rem"
                        btnFontSize = "1.125rem"
                        btnFontWeight = "700"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNavbarClick('fellow');
                        }}
                      />
                      <CommonIconButton
                        text= { t('nav.news') }
                        alignItems = "unset"
                        backgroundColor= "#ffffff"
                        btnBackgroundColor= "#ffffff"
                        btnColor = { locationVars[0] === 'news' ? '#004899' : '#000000' }
                        width= "max-content"
                        padding = "0.25rem 0.5rem"
                        btnPadding="0rem"
                        btnFontSize = "1.125rem"
                        btnFontWeight = "700"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNavbarClick('news');
                        }}
                      />
                      <CommonIconButton
                        text= { t('nav.benefit') }
                        alignItems = "unset"
                        backgroundColor= "#ffffff"
                        btnBackgroundColor= "#ffffff"
                        btnColor = { (locationVars[0] === '' || locationVars[0] === 'home' || locationVars[0] === 'index.html') && navData.isTiers ? '#004899' : '#000000' }
                        width= "max-content"
                        padding = "0.25rem 0.5rem"
                        btnPadding="0rem"
                        btnFontSize = "1.125rem"
                        btnFontWeight = "700"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNavbarClick('benefits');
                        }}
                      />
                    </>
                  )
                }
                {
                  isLogin && (
                    <>
                      <CommonIconButton
                        text= { t('nav.coupon') }
                        alignItems = "unset"
                        backgroundColor= "#ffffff"
                        btnBackgroundColor= "#ffffff"
                        btnColor = { (locationVars[0] === '' || locationVars[0] === 'home' || locationVars[0] === 'index.html') && navData.isCoupons ? '#004899' : '#000000' }
                        width= "max-content"
                        padding = "0.25rem 0.5rem"
                        btnPadding="0rem"
                        btnFontSize = "1.125rem"
                        btnFontWeight = "700"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNavbarClick('coupon');
                        }}
                      />
                      <CommonIconButton
                        text= { t('nav.profile') }
                        alignItems = "unset"
                        backgroundColor= "#ffffff"
                        btnBackgroundColor= "#ffffff"
                        btnColor = { locationVars[0] === 'setting' && locationVars[1] === 'profile' ? '#004899' : '#000000' }
                        width= "max-content"
                        padding = "0.25rem 0.5rem"
                        btnPadding="0rem"
                        btnFontSize = "1.125rem"
                        btnFontWeight = "700"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNavbarClick('profile');
                        }}
                      />
                      <CommonIconButton
                        text= { t('nav.news') }
                        alignItems = "unset"
                        backgroundColor= "#ffffff"
                        btnBackgroundColor= "#ffffff"
                        btnColor = { locationVars[0] === 'news' ? '#004899' : '#000000' }
                        width= "max-content"
                        padding = "0.25rem 0.5rem"
                        btnPadding="0rem"
                        btnFontSize = "1.125rem"
                        btnFontWeight = "700"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNavbarClick('news');
                        }}
                      />
                    </>
                  )
                }
              </div>
              <CommonIconButton
                text= { isLogin ? t('nav.logout') : t('nav.login')}
                startIcon={isLogin ? <IconLogout color='#ffffff' /> : undefined }
                alignItems = "unset"
                backgroundColor= "#000000"
                btnBackgroundColor= "#000000"
                btnColor = "#ffffff"
                width= "max-content"
                padding = "0.5rem 1.25rem"
                btnPadding="0rem"
                btnFontSize = "1.125rem"
                btnFontWeight = "700"
                onClick={(e) => {
                  e.stopPropagation();
                  isLogin ? handleNavbarClick('logout') : handleNavbarClick('login');
                }}
              />
            </div>
          )
        }
      </div>
    </div>
  );
}